/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { VideoEditorGetCompositionsByIdQueryResponse, VideoEditorGetCompositionsByIdPathParams, VideoEditorGetCompositionsByIdQueryParams, VideoEditorGetCompositionsById401, VideoEditorGetCompositionsById403 } from "../models/VideoEditorGetCompositionsById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { videoEditorGetCompositionsById } from "../axios/videoEditorGetCompositionsById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const videoEditorGetCompositionsByIdQueryKey = (id: VideoEditorGetCompositionsByIdPathParams["id"], params: VideoEditorGetCompositionsByIdQueryParams = {}) => ["api-v2", { url: '/video-editor/v1/compositions/:id', params: {id:id} }, ...(params ? [params] : [])] as const

export type VideoEditorGetCompositionsByIdQueryKey = ReturnType<typeof videoEditorGetCompositionsByIdQueryKey>

export function videoEditorGetCompositionsByIdQueryOptions(id: VideoEditorGetCompositionsByIdPathParams["id"], params?: VideoEditorGetCompositionsByIdQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = videoEditorGetCompositionsByIdQueryKey(id, params)
        return queryOptions<VideoEditorGetCompositionsByIdQueryResponse, ResponseErrorConfig<VideoEditorGetCompositionsById401 | VideoEditorGetCompositionsById403>, VideoEditorGetCompositionsByIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return videoEditorGetCompositionsById(id, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve a single Composition
 * {@link /video-editor/v1/compositions/:id}
 */
export function useVideoEditorGetCompositionsById<TData = VideoEditorGetCompositionsByIdQueryResponse, TQueryData = VideoEditorGetCompositionsByIdQueryResponse, TQueryKey extends QueryKey = VideoEditorGetCompositionsByIdQueryKey>(id: VideoEditorGetCompositionsByIdPathParams["id"], params?: VideoEditorGetCompositionsByIdQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<VideoEditorGetCompositionsByIdQueryResponse, ResponseErrorConfig<VideoEditorGetCompositionsById401 | VideoEditorGetCompositionsById403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? videoEditorGetCompositionsByIdQueryKey(id, params)
         

         const query = useQuery({
          ...videoEditorGetCompositionsByIdQueryOptions(id, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<VideoEditorGetCompositionsById401 | VideoEditorGetCompositionsById403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}